import { registerComponent } from '@gig/magic-common';
import AccountClosureFormComponent from './form.vue.js';

var AccountClosureForm = registerComponent(AccountClosureFormComponent);

export { AccountClosureForm };
